import { Box } from 'grommet'
import styled from 'styled-components'

export const HeaderImageWrapper = styled(Box)`
  position: absolute;
  right: 0;
  top: 32%;

  img {
    height: auto;
    max-width: 100%;
    object-fit: contain;
  }

  ${({ theme }) => theme.below.laptopML`
    width: 400px;
  `}
  ${({ theme }) => theme.below.laptop`
    position: relative;
    top:0px;
    margin: 0 auto;
  `}
  ${({ theme }) => theme.below.mobileL`
    width: 300px;
  `}
`
export const Wrapper = styled.div`
  .online-learning {
    ${({ theme }) => theme.below.laptopML`
      width: 400px;
      bottom: 0;
    `}
    ${({ theme }) => theme.below.laptopM`
      width: 350px;
      bottom: 4%;
    `}
  }
`
